module.exports = __webpack_public_path__ + "static/media/TERRASSE_ET_JARDIN_COMMUNS_(6).cdc1d959.jpg";